import React from 'react';
import { colors } from 'seedling/constants';

const NeutralIcon = ({ color, width, height, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
  >
    <g fill={color}>
      <path d="M10,18.8571429 C14.8916649,18.8571429 18.8571429,14.8916649 18.8571429,10 C18.8571429,5.10833507 14.8916649,1.14285714 10,1.14285714 C5.10833507,1.14285714 1.14285714,5.10833507 1.14285714,10 C1.14285714,14.8916649 5.10833507,18.8571429 10,18.8571429 Z M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z" />
      <path d="M14.0012752,9.80952381 L6,9.80952381 C5.68440871,9.80952381 5.42857143,10.0653611 5.42857143,10.3809524 C5.42857143,10.6965437 5.68440871,10.952381 6,10.952381 L14.0012752,10.952381 C14.3168665,10.952381 14.5727038,10.6965437 14.5727038,10.3809524 C14.5727038,10.0653611 14.3168665,9.80952381 14.0012752,9.80952381 Z" />
    </g>
  </svg>
);

NeutralIcon.defaultProps = {
  color: colors.darkYellow,
  width: 20,
  height: 20,
};

export default NeutralIcon;
